import styled from "styled-components";
import { COLORS } from "../../../values/colors";

export const DetailContent = styled.div`
  width: 92%;
  max-width: 1300px;
  margin: 0 auto 5rem;
  padding-top: 6.3rem;

  @media (max-width: 1180px) {
    padding-top: 7.2rem;
  }

  @media (max-width: 720px) {
    padding-top: 8.3rem;
  }
`;

export const DetailLayout = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: 1.4rem;

  @media (max-width: 920px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 560px) {
    gap: 1rem;
  }
`;

export const ImagePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const DetailEmblaViewport = styled.div`
  max-width: 100%;
  overflow: hidden;
  position: relative;
`;

export const DetailEmblaContainer = styled.div`
  display: flex;
`;

export const DetailEmblaSlide = styled.div`
  min-width: 100%;
  flex-shrink: 0;
  min-height: 32rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.3rem;
  box-sizing: border-box;

  @media (max-width: 720px) {
    min-height: 24rem;
  }

  @media (max-width: 1199px) {
    min-height: 27rem;
  }
`;

export const DetailImage = styled.img`
  width: 100%;
  max-height: 31rem;
  object-fit: contain;

  @media (max-width: 1199px) {
    max-height: 24rem;
  }

  @media (max-width: 720px) {
    max-height: 22rem;
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  min-height: 24rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.88);
  font-weight: 700;
  padding: 1rem;

  @media (max-width: 1199px) {
    min-height: 20rem;
  }

  img {
    width: min(34rem, 100%);
    height: auto;
  }
`;

export const CarouselArrow = styled.button<{ $direction: "left" | "right" }>`
  width: 3rem;
  height: 3rem;
  border: 0;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.45);
  color: ${COLORS.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ $direction }) => ($direction === "left" ? "0.85rem" : "auto")};
  right: ${({ $direction }) => ($direction === "right" ? "0.85rem" : "auto")};
  z-index: 2;

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

export const ThumbRow = styled.div`
  display: flex;
  gap: 0.65rem;
  overflow-x: auto;
  padding-bottom: 0.15rem;
`;

export const ThumbButton = styled.button<{ $active: boolean }>`
  width: 4.55rem;
  height: 4.55rem;
  flex: 0 0 auto;
  border: 1px solid ${({ $active }) => ($active ? COLORS.apronBrown : "rgba(255, 255, 255, 0.3)")};
  background: transparent;
  border-radius: 0.4rem;
  padding: 0.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ThumbImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ThumbPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  color: ${COLORS.white};
  font-size: 1rem;
  font-weight: 700;
  padding: 0.2rem;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const InfoPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const Category = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
  font-size: 0.95rem;
`;

export const Name = styled.h2`
  margin: 0;
  font-size: clamp(2rem, 3.5vw, 3rem);
  line-height: 1.1;
`;

export const Description = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
  line-height: 1.5;
  white-space: pre-line;
`;

export const Price = styled.p`
  margin: 0;
  font-size: 2.2rem;
  font-weight: 800;
`;

export const OptionSelectorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const OptionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const OptionLabel = styled.label`
  font-size: 0.9rem;
  color: ${COLORS.textSecondary};
`;

export const OptionSelect = styled.select`
  border: 1px solid ${COLORS.gray};
  background: transparent;
  color: ${COLORS.white};
  border-radius: 0.55rem;
  padding: 0.6rem 0.65rem;

  option {
    color: black;
  }
`;

export const OptionTextInput = styled.input`
  border: 1px solid ${COLORS.gray};
  background: transparent;
  color: ${COLORS.white};
  border-radius: 0.55rem;
  padding: 0.6rem 0.65rem;
`;

export const OptionValidationText = styled.p`
  margin: 0;
  font-size: 0.82rem;
  color: #ff8f8f;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 0.7rem;
  flex-wrap: wrap;

  @media (max-width: 560px) {
    align-items: stretch;

    button {
      width: 100%;
    }
  }
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
`;

export const QuantityButton = styled.button`
  border: 1px solid ${COLORS.gray};
  background: transparent;
  color: ${COLORS.white};
  font-size: 1.2rem;
  width: 2rem;
  height: 2rem;
  border-radius: 0.4rem;
  line-height: 1;
  cursor: pointer;
`;

export const QuantityValue = styled.span`
  min-width: 1.2rem;
  text-align: center;
  font-size: 1.05rem;
`;

export const Overlay = styled.button<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  border: 0;
  background: rgba(0, 0, 0, 0.42);
  z-index: 19;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  transition: opacity 0.3s ease;
`;

export const CartSlider = styled.aside<{ $open: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: min(27rem, 94vw);
  height: 100dvh;
  border-left: 1px solid ${COLORS.gray};
  background-color: ${COLORS.darkdarkGray};
  z-index: 20;
  padding: 1.2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transform: translateX(${({ $open }) => ($open ? "0%" : "100%")});
  transition: transform 0.32s ease;
`;

export const CartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CartTitle = styled.h3`
  margin: 0;
  font-size: 1.2rem;
`;

export const CloseCartButton = styled.button`
  border: 0;
  background: transparent;
  color: ${COLORS.white};
  font-size: 1.6rem;
  cursor: pointer;
`;

export const EmptyText = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
`;

export const CartList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 0.3rem;
`;

export const CartItem = styled.div`
  border: 1px solid ${COLORS.gray};
  border-radius: 0.65rem;
  padding: 0.65rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CartItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;

  @media (max-width: 420px) {
    flex-direction: column;
  }
`;

export const CartItemName = styled.p`
  margin: 0;
  font-weight: 600;
`;

export const CartItemPrice = styled.p`
  margin: 0;
  font-weight: 700;
`;

export const CartItemOptions = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: ${COLORS.textSecondary};
`;

export const RemoveButton = styled.button`
  margin-left: auto;
  border: 0;
  background: transparent;
  color: ${COLORS.textSecondary};
  cursor: pointer;
  text-decoration: underline;
`;

export const CartSummary = styled.div`
  border-top: 1px solid ${COLORS.gray};
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: auto;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CheckoutHint = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
  font-size: 0.84rem;
  line-height: 1.35;
`;

export const FaqSection = styled.section`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const FaqHeading = styled.h3`
  margin: 0;
  font-size: clamp(1.3rem, 2.1vw, 1.7rem);
`;

export const FaqCard = styled.article`
  border: 1px solid ${COLORS.gray};
  border-radius: 0.75rem;
  padding: 0.9rem 1rem;
  background: rgba(255, 255, 255, 0.03);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
`;

export const FaqQuestion = styled.h4`
  margin: 0;
  font-size: 1rem;
`;

export const FaqAnswer = styled.p`
  margin: 0;
  color: ${COLORS.textSecondary};
  line-height: 1.45;
`;
